import { render, staticRenderFns } from "./CoreLayout.vue?vue&type=template&id=1e2b2b02&"
import script from "./CoreLayout.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreLayout.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2b2b02')) {
      api.createRecord('1e2b2b02', component.options)
    } else {
      api.reload('1e2b2b02', component.options)
    }
    module.hot.accept("./CoreLayout.vue?vue&type=template&id=1e2b2b02&", function () {
      api.rerender('1e2b2b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/CoreLayout.vue"
export default component.exports